import { useSubscription } from '../context';
/**
 * Date utility functions for the WLC Cancel Modal
 * Centralizes duplicate date formatting and calculation logic
 */

/**
 * Formats a date using consistent US locale formatting
 * @param {Date} date - The date to format
 * @returns {string} Formatted date string
 */
export const formatDate = date => {
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
};

/**
 * Adds specified number of days to a date
 * @param {Date} date - The base date
 * @param {number} days - Number of days to add
 * @returns {Date} New date with added days
 */
export const addDays = (date, days) => {
  return new Date(date.getTime() + days * 24 * 60 * 60 * 1000);
};

/**
 * Calculates billing-related dates for pause scenarios
 * @param {Date} baseDate - Base date for calculations (defaults to current date)
 * @returns {object} Object containing calculated dates
 */
export const calculateBillingDates = (baseDate = new Date(), pauseDays = 30) => {
  const subscription = useSubscription();
  const oldNextBillingDate = new Date(subscription.Subscription.nextBillingDate);
  const newNextBillingDate = addDays(oldNextBillingDate, pauseDays);

  return {
    nextBillingDate: oldNextBillingDate,
    nextBillingDateAfterPause: newNextBillingDate,
    formattedNextBillingDate: formatDate(oldNextBillingDate),
    formattedNextBillingDateAfterPause: formatDate(newNextBillingDate)
  };
};
